"use client";

import { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

import { WorkspacePage } from "@/components/ds/workspace-page";
import { useAuthStore } from "@/modules/auth/store";

import { DataloggerCreateWizard } from "./components/wizard";
import { useDataloggerWizardStore } from "./hooks/use-datalogger-form";

export function DataloggerCreatePage() {
  const navigate = useNavigate();
  const reset = useDataloggerWizardStore((s) => s.reset);
  const setTenantId = useAuthStore((s) => s.setTenantId);

  useLayoutEffect(() => {
    reset();
    // New devices are platform inventory until a super admin explicitly assigns
    // them to a workspace. Never carry the list/header workspace into creation.
    setTenantId(null);
  }, [reset, setTenantId]);

  return (
    <WorkspacePage fullWidth className="space-y-ds-5 pt-0">
      <DataloggerCreateWizard onCancel={() => navigate("/devices")} />
    </WorkspacePage>
  );
}
